import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { throwError } from 'rxjs';
import { OfflineIndicatorService } from './offline-indicator';
import { ConnectivityService } from './services/connectivity.service';


export const httpsInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const offlineIndicatorService = inject(OfflineIndicatorService);
  const connectivity = inject(ConnectivityService);

  // Skip offline check if on login page
  if (router.url.includes('login')) {
    return next(request);
  }

  // ✅ App-level offline (forced) OR real offline
  const isEffectivelyOnline = connectivity.isOnlineSig();
  if (!isEffectivelyOnline) {
    offlineIndicatorService.addCancelledRequest(request);

   // Return error response
    return throwError(() => new HttpErrorResponse({
      status: 0,
      statusText: 'Offline',
      url: request.url,
      error: { message: 'No internet connection' }
    }));
  }

  // Auth header
  let authReq = request;

  const userJson = localStorage.getItem('currentUser');
  if (userJson) {
    const currentUser = JSON.parse(userJson);
    const decoded: any = jwtDecode(currentUser.token);

    const isExpired = decoded?.exp && decoded.exp < Date.now() / 1000;
    if (isExpired) router.navigateByUrl('login');

    if (currentUser.token) {
      authReq = request.clone({
        setHeaders: { Authorization: `${currentUser.token}` },
      });
    }
  }

  return next(authReq);
};